import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { PromptService } from 'src/app/services/prompt.service';
import { ToastService } from 'src/app/services/toast.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { ProjectService } from 'src/app/services/project.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  newPassword = {
    focused: false,
    value: '',
  };
  status = { admin: null, onlyMember: null, onlyAdmin: null };
  newEmail = '';
  newEmailError = '';
  newEmailMessage = '';
  newPasswordError = '';
  newPasswordMessage = '';
  tags = {
    standard: [
      'technology',
      'environmental-impacts',
      'governance',
      'markets-finance',
      'funding',
      'cdr-community',
      'social-licensing',
    ],
    approaches: ['microalgae', 'blue-carbon', 'macroalgal', 'alkalinity', 'co2-removal', 'storage', 'other'],
  };
  subscriptionNum = 0;
  isMailchimpMember = false;
  interestsMap = {
    '14aa87d2e7': 'CDR Community Updates',
    '3437e7a37b': 'OV News & Updates',
    'b2be26680e': 'Road Maps Updates'
  };
  userInterests = {
    '14aa87d2e7': false,
    '3437e7a37b': false,
    'b2be26680e': false
  };

  constructor(
    private userService: UserService,
    private promptService: PromptService,
    private toastService: ToastService,
    private institutionService: InstitutionService,
    private projectService: ProjectService,
    private loadingService: LoadingService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const action = this.route.snapshot.params.action;

    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;

          if (action === 'ovconnect') {
            // object to serialize and send to ocean visions
            let ov = {
              ocdr: true,
              email: this.currentUser.email,
              first: this.currentUser.firstName,
              last: this.currentUser.lastName,
              title: this.currentUser.title ? this.currentUser.title : '',
              institution: this.currentUser.institution ? this.currentUser.institution : ''
            }
            let urlParams = '';
            for (let key in ov) {
              if (urlParams != '') {
                urlParams += '&';
              }
              urlParams += (key + '=' + encodeURIComponent(ov[key]));
            }
            window.location.href = 'https://oceanvisions.org/register/?' + urlParams;
          }

          this.userService.getMembers().subscribe(users => {
            if (users) {
              users.forEach((u: any) => {
                if (!u.notificationSettings.tags) u.notificationSettings.tags = [...this.tags.standard, ...this.tags.approaches];
                this.userService.saveUser(u.uid, u);
              })
            }
          })

          // this.currentUser.email
          this.userService.getMailchimpMember(this.currentUser.email).subscribe((member: any) => {
            if (member) {
              this.isMailchimpMember = true;
              if (member.interests) {
                this.userInterests['14aa87d2e7'] = member.interests['14aa87d2e7'];
                this.userInterests['3437e7a37b'] = member.interests['3437e7a37b'];
                this.userInterests['b2be26680e'] = member.interests['b2be26680e'];
              }
            }
          }, (error) => {
            console.log('No mailchimp member associated with this user');
          });
          
          this.updateSubscriptionNum();

          this.status = this.checkAdminStatus();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  saveNotificationSettings() {
    const upd = {
      notificationSettings: this.currentUser.notificationSettings,
    };
    this.userService
      .saveUser(this.currentUser.uid, upd)
      .then(() => {
        this.toastService.setToast('<div class="txt-c">Preferences saved</div>')
      })
      .catch((error) => {
        console.error(error);
      });
  }

  saveNewsletterSettings() {
    this.loadingService.startLoading();
    /*
    let interestsArray = [];
    for (const [k, v] of Object.entries(this.userInterests)) {
      interestsArray.push({ name: this.interestsMap[k], value: v ? 'active' : 'inactive'});
    }
    */
    this.userService.addOrUpdateMailchimpMember(this.currentUser.firstName, this.currentUser.lastName, this.currentUser.email, this.userInterests, !this.isMailchimpMember).subscribe(() => {
        this.loadingService.stopLoading();
        this.toastService.setToast('<div class="txt-c">Newsletter preferences saved</div>');
      }, (error) => {
        this.loadingService.stopLoading();
        this.toastService.setToast('<div class="txt-c">Newsletter preferences could not be saved</div>');
      });
  }

  changeEmail() {
    this.loadingService.startLoading();
    this.userService
      .updateEmail(this.newEmail)
      .then(() => {
        this.currentUser.email = this.newEmail;
        this.userService.saveUser(this.currentUser.uid, this.currentUser)
          .then(() => {
            this.loadingService.stopLoading();
            this.toastService.setToast('Email updated')
          })
      })
      .catch((err) => {
        console.error(err);
        this.loadingService.stopLoading();
        this.newEmailError = err.message;
      });
  }
  changePassword() {
    this.loadingService.startLoading();
    this.userService
      .updatePassword(this.newPassword.value)
      .then(() => {
        this.loadingService.stopLoading();
        this.toastService.setToast('Password updated')
      })
      .catch((err) => {
        this.loadingService.stopLoading();
        console.error(err);
        this.newPasswordError = err.message;
      });
  }

  promptDisableAccount() {
    console.log(this.status);
    // If user needs to transfer admin roles
    if (this.status && this.status.admin && !this.status.onlyMember && this.status.onlyAdmin) {
      this.promptService.setPrompt({
        hidden: false,
        heading: 'You are an active admin!',
        body: 'Please transfer your admin roles in any active projects or institutions before disabling your account.',
        confirmText: 'Transfer admin roles',
        rejectText: 'Nevermind',
      });

      // If user doesn't have any admin roles or has no one to transfer to
    } else {
      this.promptService.setPrompt({
        hidden: false,
        heading: 'Are you sure you want to disable your account?',
        body:
          'Other members won’t be able to see your contact information, active projects and affiliated institutions. ',
        confirmText: 'Disable account',
        rejectText: 'Nevermind',
      });
    }
    this.promptService.userResponse.subscribe((res) => {
      if (res === 'confirm') {
        this.promptService.clearPrompt();
        this.status && this.status.admin && !this.status.onlyMember && this.status.onlyAdmin
          ? this.transferAdminRoles()
          : this.disableAccount();
      } else if (res === 'reject') {
        this.promptService.clearPrompt();
      }
    });
  }

  transferAdminRoles() {
    this.router.navigate(['/m/transfer-roles']);
  }

  disableAccount() {
    this.currentUser.disabled = true;
    this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
      this.router.navigate(['/m/disabled']);
    });
  }

  checkAdminStatus(): any {
    ['institution', 'project'].forEach((type) => {
      for (const k in this.currentUser[type + 'Roles']) {
        if (Object.prototype.hasOwnProperty.call(this.currentUser[type + 'Roles'], k)) {
          if (this.currentUser[type + 'Roles'][k].role === 'admin') {
            const typeLabel = type.charAt(0).toUpperCase() + type.substring(1);
            this[type + 'Service']['get' + typeLabel + 'Members'](k).subscribe((members) => {
              if (members && members.length > 1) {
                // if other admins exist
                if (
                  members.filter(member => member.uid !== this.currentUser.uid) // filter out current user
                    .some((member) => member[type + 'Roles'][k].role === 'admin') // check if another admin exists
                ) {
                  console.log('other admins exist', members)
                  this.status = { admin: true, onlyMember: false, onlyAdmin: false };
                } else {
                  console.log('other admins dont exist')
                  this.status = { admin: true, onlyMember: false, onlyAdmin: true };
                }
              } else if (members && members.length <= 1) {
                this.status = { admin: true, onlyMember: true, onlyAdmin: true };
              }
            });
          } else {
            this.status = { admin: false, onlyMember: true, onlyAdmin: true };
          }
        } else {
          this.status = { admin: false, onlyMember: null, onlyAdmin: null };
        }
      }
    });
  }

  toggleTag(t): void {
    if (this.currentUser.notificationSettings.tags.indexOf(t) === -1) {
      this.currentUser.notificationSettings.tags.push(t);
    } else {
      this.currentUser.notificationSettings.tags.splice(this.currentUser.notificationSettings.tags.indexOf(t), 1);
    }
    this.updateSubscriptionNum();
  }

  updateSubscriptionNum() {
    this.subscriptionNum = this.currentUser.notificationSettings.tags.filter(tag => {
      return tag != 'fertilization' && tag != 'upwelling' && tag != 'downwelling' && tag != 'other-bio' && tag != 'other-abio'
    }).length
  }
}
